
export const METADATA_GROUPS = [
  { key: 'fiscal', label: 'Fiscal / DFe' },
  { key: 'fines', label: 'Multas / Frotas' },
  { key: 'integrations', label: 'Integrações' },
  { key: 'internal', label: 'Controle interno' }
]

export const ACCOUNT_METADATA_CATALOG = [
  {
    key: 'distribution_cte',
    group: 'fiscal',
    label: 'Distribuição de CT-e',
    description: 'Busca automática de CT-e na SEFAZ.'
  },
  {
    key: 'distribution_nfe',
    group: 'fiscal',
    label: 'Distribuição de NF-e',
    description: 'Busca automática de NF-e na SEFAZ.'
  },
  {
    key: 'distribution_nfse_default',
    group: 'fiscal',
    label: 'Distribuição de NFS-e padrão',
    description: 'Coleta de NFS-e pelo fluxo padrão.'
  },
  {
    key: 'distribution_nfse_city_hall_mapper',
    group: 'fiscal',
    label: 'NFS-e via city hall mapper',
    description: 'Coleta de NFS-e pelo robô de prefeituras.'
  },
  {
    key: 'dfe_synchronize_nfse_nacional',
    group: 'fiscal',
    label: 'Sincronizar NFS-e Nacional',
    description: 'Habilita a sincronização com o ambiente nacional de NFS-e.'
  },
  {
    key: 'dfe_allow_old_archive',
    group: 'fiscal',
    label: 'Aceitar XML antigo',
    description: 'Permite importar arquivos com data de emissão fora do período corrente.'
  },
  {
    key: 'check_participants',
    group: 'fiscal',
    label: 'Verificar participantes',
    description: 'Valida emitente e destinatário na criação de documentos.'
  },
  {
    key: 'xml_authenticator',
    group: 'fiscal',
    label: 'Autenticador de XML',
    description: 'Exige autenticação do XML antes do envio à prefeitura.'
  },
  {
    key: 'allow_crossing',
    group: 'fines',
    label: 'Cruzamento de dados',
    description: 'Libera as colunas de motorista e CPF nos relatórios de frotas.'
  },
  {
    key: 'allow_lessee_crossing',
    group: 'fines',
    label: 'Cruzamento por locatário',
    description: 'Libera o cruzamento por locatário no CaçaMultas Frotas: planilha de locações, colunas de locatário e locatário no demonstrativo.'
  },
  {
    key: 'autos_antt_sem_boleto',
    group: 'fines',
    label: 'ANTT sem boleto',
    description: 'Ignora a emissão de boleto nas consultas da ANTT.'
  },
  {
    key: 'relatoriofrotas_engemix',
    group: 'fines',
    label: 'Relatório de frotas Engemix',
    description: 'Layout de relatório específico do cliente Engemix.'
  },
  {
    key: 'unico_integration',
    group: 'integrations',
    label: 'Integração Unico',
    description: 'Exibe o menu da integração Unico para o owner da conta.'
  },
  {
    key: 'webhook',
    group: 'integrations',
    label: 'Webhooks',
    description: 'Libera o envio de eventos para URLs externas.'
  },
  {
    key: 'sem_parar',
    group: 'integrations',
    label: 'Sem Parar',
    description: 'Conta originada ou integrada ao Sem Parar.'
  },
  {
    key: 'sent_creation_email',
    group: 'internal',
    label: 'E-mail de criação enviado',
    description: 'Escrito pelo backend ao concluir o cadastro. Alterar aqui reenvia o e-mail.'
  },
  {
    key: 'skip',
    group: 'internal',
    label: 'Pular distribuição',
    description: 'Suspende os jobs de distribuição de documentos da conta na janela de horário definida.'
  }
]

export const HOUR_RANGE_FIELD = 'skip'

export const HOUR_RANGE_KEYS = {
  start: 'skip_start_time',
  end: 'skip_end_time'
}

export const CAPTURE_CRLV_KEY = 'capturar_crlv'

const TRUTHY_VALUES = [true, 'true', 1, '1']

export const BLOCK_CRLV_KEY = 'bloquear_crlv'

export const BLOCK_CRLV_EXPLANATION = [
  'Por padrão todo cliente pode ativar a captura do CRLV por veículo em Definições > Veículos, ' +
    'aceitando o valor por documento capturado.',
  'Ligue este bloqueio apenas para contas que não devem usar o recurso: o cliente deixa de ' +
    'conseguir ativar novas capturas.',
  'Pedidos em andamento seguem até o fim e documentos capturados permanecem. Ativações e ' +
    'faturamento ficam em Admin > CRLV (Platform New).'
]

export function isCrlvBlocked(metadata) {
  const value = (metadata || {})[BLOCK_CRLV_KEY]

  return TRUTHY_VALUES.includes(value)
}

export function blockCrlvStatusLabel(blocked) {
  return blocked
    ? 'Bloqueado — a conta não consegue ativar novas capturas'
    : 'Liberado — o cliente ativa por veículo e aceita o valor por documento'
}

export const CRLV_NEGOTIATED_PRICE_KEY = 'crlv_preco_negociado'

export const CRLV_NEGOTIATED_PRICE_EXPLANATION = [
  'Tabela padrão por documento capturado, pela quantidade de placas já ativadas: até 100 placas R$ 10; ' +
    '101 a 500 R$ 8; 501 a 1.000 R$ 6; acima de 1.000 R$ 5.',
  'Preencha apenas quando houver valor negociado com o cliente, em reais (ex.: 4,50). Ele substitui a tabela ' +
    'nas próximas ativações da conta; o cliente vê o valor na hora do aceite e ele fica gravado no termo.',
  'Ativações já feitas mantêm o preço aceito. Deixe vazio para voltar à tabela padrão.'
]

export function crlvNegotiatedPrice(metadata) {
  const value = (metadata || {})[CRLV_NEGOTIATED_PRICE_KEY]

  return value === undefined || value === null ? '' : String(value).replace('.', ',')
}

export function isCrlvNegotiatedPriceValid(text) {
  const value = String(text || '').trim()

  return value === '' || (/^\d+([.,]\d{1,2})?$/.test(value) && Number(value.replace(',', '.')) > 0)
}

export const METADATA_KEYS_HANDLED_ELSEWHERE = [
  'step',
  'cache_app_ids',
  'driver_indication',
  'lane',
  'spider_params',
  CAPTURE_CRLV_KEY,
  BLOCK_CRLV_KEY,
  CRLV_NEGOTIATED_PRICE_KEY,
  HOUR_RANGE_KEYS.start,
  HOUR_RANGE_KEYS.end
]

const CATALOG_BY_KEY = ACCOUNT_METADATA_CATALOG.reduce((acc, field) => {
  acc[field.key] = field
  return acc
}, {})

export function findMetadataField(key) {
  return CATALOG_BY_KEY[key] || null
}

export function isCatalogedKey(key) {
  return !!CATALOG_BY_KEY[key]
}

export function metadataFieldsByGroup() {
  return METADATA_GROUPS
    .map(group => ({
      ...group,
      fields: ACCOUNT_METADATA_CATALOG.filter(field => field.group === group.key)
    }))
    .filter(group => group.fields.length > 0)
}

export function uncatalogedEntries(metadata) {
  if (!metadata || typeof metadata !== 'object')
    return []

  return Object.keys(metadata)
    .filter(key => !isCatalogedKey(key))
    .filter(key => !METADATA_KEYS_HANDLED_ELSEWHERE.includes(key))
    .sort()
    .map(key => ({ key: key, value: metadata[key] }))
}
